import { render, staticRenderFns } from "./textEditor.component.vue?vue&type=template&id=b83333e8&scoped=true&"
import script from "./textEditor.component.vue?vue&type=script&lang=js&"
export * from "./textEditor.component.vue?vue&type=script&lang=js&"
import style0 from "./textEditor.component.vue?vue&type=style&index=0&id=b83333e8&lang=scss&scoped=true&"
import style1 from "./textEditor.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83333e8",
  null
  
)

export default component.exports